import React, { useCallback } from "react";
import { Controller, ControllerProps, useFormContext } from "react-hook-form";
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  FormHelperText,
} from "@material-ui/core";
import { RadioGroupProps } from "@material-ui/core/RadioGroup/RadioGroup";
import { SelectorProps } from "./index";

interface RadioProps extends RadioGroupProps {
  "data-testid"?: string;
}
interface RadioSelectorProps extends SelectorProps {
  radioProps?: Partial<RadioProps>;
  controllerProps?: Partial<ControllerProps<typeof RadioGroup>>;
}

export const RadioSelector: React.FC<RadioSelectorProps> = ({
  name,
  options,
  onChange,
  radioProps,
  controllerProps,
}) => {
  const { control } = useFormContext(); // Must provide a FormContext wrapper for this component
  const handleChange = useCallback(
    ([event]) => {
      const v = String(event.target.value);
      if (onChange) {
        onChange(v);
      }
      return v; // Must return value being set
    },
    [onChange],
  );

  return (
    <Controller
      as={
        <RadioGroup row {...radioProps}>
          {options.map((opt) => (
            <Box mr={3} key={`opt-${opt.value}`}>
              <FormControlLabel
                value={opt.value}
                control={<Radio color="secondary" />}
                label={opt.name}
                labelPlacement="end"
              />
              {opt?.helperText && (
                <Box ml={4} maxWidth={200} mt={-1.5}>
                  <FormHelperText>{opt.helperText}</FormHelperText>
                </Box>
              )}
            </Box>
          ))}
        </RadioGroup>
      }
      {...controllerProps}
      name={name}
      defaultValue={controllerProps?.defaultValue ?? options[0]!.value}
      control={control}
      onChange={handleChange}
    />
  );
};
